import {apiHelper,PromiseHandler} from "../redux/apiHelper"
const deleteBlogCategoryById=(id)=>PromiseHandler(apiHelper('post',`/api/admin/blog/category/delete/${id}`))
const getBlogCategories=()=>PromiseHandler(apiHelper('get','/api/admin/blog/category/get'))
const getBlogCategoriesActive=()=>PromiseHandler(apiHelper('get','/api/admin/blog/category/get?status=true'))
const getBlogCategoryById=(id)=>PromiseHandler(apiHelper('get',`/api/admin/blog/category/get/${id}`))
const updateBlogCategoryById=(id,data)=>PromiseHandler(apiHelper('post',`/api/admin/blog/category/update/${id}`,data))
const addBlogCategory=(data)=>PromiseHandler(apiHelper('post','/api/admin/blog/category/create',data))

export {deleteBlogCategoryById,getBlogCategories,getBlogCategoryById,addBlogCategory,updateBlogCategoryById,getBlogCategoriesActive}
